import { useEffect, useMemo, useState } from "react";
import imagesPath from "../data/imagesPath"

export default function ShareBuy({company,shares}:{company?:string,shares?:number}) {
  const [disabledClaim,setDisabledClaim] = useState<boolean>(false) 

  const data = useMemo(() => {
    return imagesPath.find((e) => e.company === company);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesPath, company]);

  useEffect(()=>{
    if(company === "Tesla" || company === "Disney" || company === "Live Nation"){
      setDisabledClaim(false)
    }else{
      setDisabledClaim(true)
    }
  },[company])
  

  return (
    <div
      className="w-full h-full bg-white rounded-lg overflow-hidden mb-8"
      style={{
        boxShadow: "0px 23px 44px 0px rgba(176, 183, 195, 1)",
      }}
    >
      <div className="p-3">
        {/* Tesla Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={data?.banner}
            alt="Tesla Logo"
            className="h-[110px]  w-full"
          />
        </div>
        <div className="px-2">
          {/* Requirements */}
          <div className="space-y-2  ">
            <div className="flex items-start gap-2">
              <div className="w-6 h-6">
                {/* eslint-disable-next-line jsx-a11y/alt-text */}
                <img src="/close.svg" />
              </div>
              <span className="text-sm text-[#EA4334]">
                Minimum of {shares ? shares : 1000} Shares
              </span>
            </div>
            <div className="flex items-start gap-2">
              <div className="w-6 h-6">
                {/* eslint-disable-next-line jsx-a11y/alt-text */}
                <img src="/tick.svg" />
              </div>
              <span className="text-sm text-gray-700">
                Only for {company} Shareholders
              </span>
            </div>
            <div className="flex items-center gap-2 mb-2">
              {/* <span className="bg-[#F0F1FF] text-[#5263FF] text-[16px] font-semibold px-2 py-1 rounded flex items-center gap-2">
                <img src="/votr_purple.png" className="h-5 w-5 p-0.5" />
                VOTR ACCESS{" "}
              </span> */}
            </div>
          </div>

          {/* Deposit Info */}
          <div className="mb-4 ml-2">
            <div className="text-2xl font-bold">$200 Deposit</div>
            <div className="text-sm text-gray-500">Available Passes: 10</div>
          </div>

          {/* Claim Access */}
          <div className={`${disabledClaim ? "bg-[#E6E6E9]" : "bg-[#65b560]" } p-4 rounded-lg mb-4 flex items-center gap-2 justify-center text-lg font-medium ml-2`}>
            <svg
              className={`w-4 h-4  ${disabledClaim ? "text-[#8C8E9C]" : "text-[#65b560]"}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
            <span className={ `${disabledClaim ? "text-[#8C8E9C]" : "text-[#fff]" }`}>Claim Early Access</span>
          </div>

          {/* Eligibility */}
          <div className="mb-6 ml-2">
            <div className="text-sm font-medium mb-2">Eligibility</div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-[#4CAF50] h-2 rounded-full"
                style={{ width: `${disabledClaim ? "70%" : "100%"}` }}
              ></div>
            </div>
           {disabledClaim &&
           <div className="text-xs text-gray-500 mt-2">
              You need to buy 100 more shares to unlock this
            </div> 
            }
          </div>

          {/* Action Button */}
          <button disabled={!disabledClaim}  className={`w-full ${disabledClaim ? "bg-[#D63B3B]" : "bg-[#E6E6E9]" }  text-white py-3 rounded-lg font-medium ${disabledClaim && "hover:bg-[#C23535]"}  transition-colors`}>
            Buy More Shares
          </button>
        </div>
      </div>
    </div>
  );
}

